import React, { useContext, useEffect, useState } from "react";
import { Avatar } from "antd";
import { Space, Popover, Button } from "react_reusable_components";

import variables from "../../themes/base/styles/variables";
import MyAccountsPopUpContent from "../MyAccountsPopUpContent/MyAccountsPopUpContent";
import { AuthContext } from "../../globalContext/auth/authProvider";
import useResponsive from "core/hooks/useResponsive";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { useIntl } from "react-intl";
import MediaService from "../../services/media-service";

const MyAccountsPopupContainerStyle = {
  avatarStyle: {
    background: variables.avatarBG,
    height: variables.avatarMini,
    width: variables.avatarMini,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    margin: `0 ${variables.marginAuto}`,
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightNormal,
  },
  overlayStyle: {
    border: variables.popoverBorder,
    backgroundColor: variables.bodyBg,
    top: variables.accountsPopUpTop,
  },
  downArrow: {
    height: variables.navDownArroWIcon,
    width: variables.navDownArroWIcon,
  },
  downArrowButton: {
    all: variables.unset,
    marginLeft: variables.marginMediumSmall,
    cursor: "pointer",
  },
};

export default function MyAccountsPopupContainer() {
  const [authState] = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const loaderDispatch = useContext(GlobalLoaderContext)[1];
  const [imageDataUrl, setImageDataUrl] = useState("");
  const [switchProfilePopUp, setSwitchProfilePopUp] = useState(false);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
    if (!newOpen) setSwitchProfilePopUp(false);
  };

  const responsive = useResponsive();
  const intl = useIntl();

  const { name, imageId = "" } = authState?.data || {};

  useEffect(() => {
    if (imageId) {
      MediaService?.getMediaData({
        loaderDispatch,
        mediaId: imageId,
        intl,
      }).then((res) => {
        let url = URL.createObjectURL(res?.data);
        setImageDataUrl(url);
      });
    }
  }, [imageId]);

  return (
    <Popover
      open={open}
      onOpenChange={handleOpenChange}
      trigger="click"
      arrow={false}
      overlayStyle={MyAccountsPopupContainerStyle.overlayStyle}
      placement={"bottomRight"}
      content={
        <MyAccountsPopUpContent
          switchProfilePopUp={switchProfilePopUp}
          setSwitchProfilePopUp={setSwitchProfilePopUp}
          handleOpenChange={handleOpenChange}
        />
      }
    >
      <Space size={0}>
        <Avatar
          src={imageDataUrl}
          style={{
            ...MyAccountsPopupContainerStyle.avatarStyle,
            ...(imageDataUrl?.length > 0 && { background: "none" }),
          }}
        >
          {name?.[0]?.toUpperCase()}
          {name?.split?.(" ")?.[1]?.[0]?.toUpperCase()}
        </Avatar>
        {responsive.isMd && (
          <Button
            style={MyAccountsPopupContainerStyle.downArrowButton}
            icon={
              <img
                src={open ? "downArrowFill.svg" : "/downArrow.svg"}
                style={MyAccountsPopupContainerStyle.downArrow}
              />
            }
          />
        )}
      </Space>
    </Popover>
  );
}
